export function TwoIcon({ width = 41, height = 61 }) {
  return (
    <svg width={width} height={height} viewBox='0 0 41 61' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g filter='url(#filter0_i_1177_1162)'>
        <path
          d='M20.2402 32.384C22.9389 29.8027 24.9629 27.4853 26.3122 25.432C27.7203 23.3787 28.4243 21.1493 28.4243 18.744C28.4243 16.1627 27.6909 14.1973 26.2243 12.848C24.8162 11.44 22.9389 10.736 20.5922 10.736C17.8349 10.736 15.6056 11.6747 13.9042 13.552C12.2616 15.3707 10.9123 17.8933 9.85625 21.12L0.000250021 16.984C1.40825 11.7627 3.98958 7.62666 7.74425 4.576C11.4989 1.52533 16.1336 1.25408e-07 21.6482 1.25408e-07C25.4616 1.25408e-07 28.8056 0.762667 31.6803 2.288C34.6136 3.81333 36.8429 5.896 38.3683 8.536C39.9523 11.176 40.7443 14.1387 40.7443 17.424C40.7443 21.2373 39.9229 24.5813 38.2802 27.456C36.6962 30.3307 34.3202 33.2053 31.1522 36.08L17.6882 48.84V49.104H41.0082V60.104H1.32025V50.424L20.2402 32.384Z'
          fill='#F5F7F9'
        />
      </g>
      <defs>
        <filter id='filter0_i_1177_1162' x='0' y='0' width='44.0078' height='60.104' filterUnits='userSpaceOnUse' colorInterpolationFilters='sRGB'>
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dx='3' />
          <feGaussianBlur stdDeviation='2.5' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0' />
          <feBlend mode='normal' in2='shape' result='effect1_innerShadow_1177_1162' />
        </filter>
      </defs>
    </svg>
  );
}
